import React, { useEffect, useState } from "react";
import {
  Grid,
  Chip,
  Typography,
  useMediaQuery,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Stack,
  Divider,
  Button,
  Skeleton,
  Card,
  Paper,
} from "@mui/material";
import FeedIcon from "@mui/icons-material/Feed";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CircleIcon from "@mui/icons-material/Circle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { useNavigate } from "react-router-dom";
import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import CandidateProfilePage from "../CandidateProfile/CandidateProfilePage";

const CandidateDash = () => {
  const { candidateJobData, notifications } = useCandidateLayout();

  const Navigate = useNavigate();

  const jobTitle = candidateJobData[0]?.JD_Title;
  const jobId = candidateJobData[0]?.JD_JobId;
  const stages = candidateJobData[0]?.recruitment_json
    ? JSON.parse(candidateJobData[0].recruitment_json)?.stages || []
    : [];

  return (
    <Paper
      sx={{
        padding: 2,
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
        maxWidth: "100vw",
        boxShadow: "none",
      }}
    >
      {/* Job Procedure Mapping */}
      <Grid container>
        {jobId && jobTitle && (
          <Grid
            item
            xs={12}
            sx={{
              border: "1px solid #006CB880",
              margin: "10px auto",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                alignItems: "center",
                marginBottom: "20px",
                gap: 1, // optional spacing between wrapped items
              }}
            >
              {/* Application Progress - Job Title */}
              <Typography
                sx={{
                  px: 2,
                  textAlign: "left",
                  fontFamily: "Geist, sans-serif",
                  letterSpacing: `0.5px`,
                  fontSize: "22px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                {`(${jobId}) - ${jobTitle}`}
              </Typography>
              <Button
                variant="text"
                onClick={() => Navigate(`/Jobs`)}
                sx={{
                  minWidth: "100px",
                  color: "white",
                  background: "#006CB8",
                  mt: 0.5,
                  height: "30px",
                  textTransform: "capitalize",
                  ml: "auto", // pushes right when wrapped
                }}
              >
                View All
              </Button>
            </Box>

            {/* Horizontal Scrollable Box of Stages */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "nowrap",
                overflowX: "auto",
              }}
            >
              {stages?.map((stage, stageIndex) => {
                const hasSubProcedures =
                  stage?.subProcedures && stage.subProcedures.length > 0;

                const subComponents = hasSubProcedures
                  ? stage.subProcedures.map((sub) => {
                      const field = sub.fields?.find(
                        (f) => f?.RPF_Type === "IsCompleted"
                      );

                      const rawValue = Array.isArray(field?.RPF_Value)
                        ? field?.RPF_Value[0]
                        : field?.RPF_Value;
                      const isCompleted = rawValue;

                      return { ...sub, isCompleted };
                    })
                  : [];

                let stageStatus = 0;
                let stageStatusField = null;

                if (!hasSubProcedures) {
                  stageStatusField = stage.fields?.find(
                    (field) => field?.RPF_Type === "IsCompleted"
                  );
                  const rawValue = Array.isArray(stageStatusField?.RPF_Value)
                    ? stageStatusField?.RPF_Value[0]
                    : stageStatusField?.RPF_Value;
                  stageStatus = parseInt(rawValue || "0");
                } else {
                  const subCompletionFlags = subComponents.map((sub) =>
                    sub.isCompleted == 1 ? 1 : 0
                  );

                  const allCompleted = subCompletionFlags.every((v) => v === 1);
                  stageStatus = allCompleted ? 1 : 0;
                }

                const getColorStyles = (status) => {
                  switch (status) {
                    case 1:
                      return { border: "#22C55E", background: "#22C55E1A" };
                    case 2:
                      return { border: "#9CA3AF", background: "#F3F4F6" };
                    case 3:
                      return { border: "#3B82F6", background: "#3B82F61A" };
                    default:
                      return { border: "#3B82F6", background: "#3B82F61A" };
                  }
                };


                const { border: stageBorderColor, background: stageBgColor } =  getColorStyles(stageStatus);

                const fieldsOnly = stage?.fields || [];
                const subProcedureFields = (stage?.subProcedures || []).flatMap((sub) => sub?.fields || []);


                const stageStatusFieldMain = fieldsOnly.find((field) =>
                  field?.RPF_Name?.trim()?.toLowerCase().includes("status")
                );

                const stageStatusSubField = subProcedureFields.find((field) =>
                  field?.RPF_Name?.trim()?.toLowerCase().includes("status")
                );

                // Color code for sidebar
                const getStageColor = (status) => {
                  switch (status) {
                    case "1":
                      return {
                        border: "#22C55E", //Green
                        bg: "#22C55E0D",
                        label: "Completed",
                      };
                    case "2":
                      return {
                        border: "#9CA3AF", // Greyish (Tailwind's gray-400)
                        bg: "#9CA3AF0D",
                        label: "Draft",
                      };
                    default:
                      return {
                        border: "#006CB8", // Blue
                        bg: "#EBF2FF",
                        label: "In Progress",
                      };
                  }
                };
                // 0 = in progress
                // 1 = completed
                // 2 = Draft

              function getExpiryStatus(field) {
                    if (field.RPF_Type !== "Date") return null;

                    // 🔹 Check if expiry is enabled
                    if (field.RPF_IsExpiry == undefined) {
                      return null;
                    }

                    // 1. Parse expiry period
                    let expiryDays = 0;
                    if (
                      field.RPF_ExpiryPeriod &&
                      field.RPF_IsExpiry != undefined
                    ) {
                      try {
                        expiryDays = Number(
                          field.RPF_ExpiryPeriod.toString().replace(/"/g, "")
                        );
                      } catch {
                        expiryDays = 0;
                      }
                    }

                    // 2. Parse the base date (RPF_Value)
                    if (!field.RPF_Value) return null;
                    const baseDate = new Date(field.RPF_Value);
                    if (isNaN(baseDate)) return null;

                    // 3. Calculate expiry date
                    const expiryDate = new Date(baseDate);
                    expiryDate.setDate(baseDate.getDate() + expiryDays);

                    // 4. Compare with today
                    const today = new Date();
                    const diffTime = expiryDate - today;
                    const diffDays = Math.ceil(
                      diffTime / (1000 * 60 * 60 * 24)
                    );

                    // Helper for singular/plural
                    const dayLabel = (n) =>
                      Math.abs(n) === 1 ? "day" : "days";

                    // 5. Handle result
                    if (diffDays > 30) {
                      return null; // don’t show if more than 30 days left
                    } else if (diffDays > 0) {
                      return {
                        value: `${field.RPF_Name}: ${diffDays} ${dayLabel(
                          diffDays
                        )} pending`,
                        fontSize: "16px",
                        color: "black",
                      };
                    } else if (diffDays === 0) {
                      return {
                        value: `${field.RPF_Name}: Expires today`,
                        fontSize: "16px",
                        color: "black",
                      };
                    } else if (diffDays >= -60) {
                      return {
                        value: `${field.RPF_Name}: Expired ${Math.abs(
                          diffDays
                        )} ${dayLabel(diffDays)} ago`,
                        fontSize: "16px",
                        color: "red",
                      };
                    } else {
                      return null; // don’t show if expired more than 60 days ago
                    }
                  }

                return (
                  <Box
                    key={stageIndex}
                    sx={{
                      minWidth: "300px",
                      // minHeight: "250px",
                      border: `2px solid ${stageBorderColor}`,
                      backgroundColor: stageBgColor,
                      borderRadius: 2,
                      m: 2,
                      p: 2,
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
                      display: hasSubProcedures ? "block" : "flex",
                      flexDirection: hasSubProcedures ? "initial" : "column",
                      alignItems: `center`,
                      alignContent: `center`,
                      justifyContent: `center`,
                      textAlign: `center`,
                    }}
                  >
                    {/* Main Stage */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        alignContent: "center",
                        justifyContent: `center`,
                        position: "relative",
                        top: "18px",
                      }}
                    >
                      {stageStatus === 1 ? (
                        <CheckCircleIcon
                          sx={{ color: "#22C55E", fontSize: 30, mx: 1 }}
                        />
                      ) : stageStatus === 2 ? (
                        <FeedIcon
                          sx={{ color: "#9CA3AF", fontSize: 24, mx: 1 }}
                        />
                      ) : (
                        <AccessTimeIcon
                          sx={{ color: "#3B82F6", fontSize: 30, mx: 1 }}
                        />
                      )}
                      <Typography
                        fontWeight={600}
                        fontSize={16}
                        sx={{
                          textTransform: "capitalize",
                          fontFamily: "Geist, sans-serif",
                        }}
                      >
                        {stage?.RPS_Name || "Unnamed Stage"}
                      </Typography>

                      {/* New Implementation - 09-09-25 - Expiry Date */}

                      {stage?.fields?.map((field) => {
                        const status = getExpiryStatus(field);
                        return (
                          <Box key={field.RPF_Id}>
                            {status?.value && (
                              <Typography
                                sx={{
                                  fontSize: status?.fontSize,
                                  color: status?.color,
                                  textTransform: "Capitalize",
                                  textAlign:'left'
                                }}
                              >
                                {status?.value}
                              </Typography>
                            )}
                          </Box>
                        );
                      })}
                    </Box>

                    <Divider sx={{ my: 2.5 }} />

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        alignContent: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        fontWeight={600}
                        sx={{
                          textTransform: "capitalize",
                          fontFamily: "Geist, sans-serif",
                          fontSize: "14",
                        }}
                      >
                        {stageStatusFieldMain?.RPF_Name &&
                        stageStatusFieldMain?.RPF_Value
                          ? `${stageStatusFieldMain?.RPF_Name} : ${stageStatusFieldMain?.RPF_Value}`
                          : null}
                      </Typography>
                    </Box>

                    {hasSubProcedures &&
                      subComponents.map((sub, subIndex) => {
                        const subStatus = sub.isCompleted;

                        const subColor = getStageColor(subStatus);

                        const stageStatusSubFieldPosition = (
                          sub?.fields || []
                        ).find(
                          (field) =>
                            field?.RPF_Id == stageStatusSubField?.RPF_Id
                        );

                        return (
                          <Box
                            sx={{
                              px: 1.5,
                              borderLeft: `4px solid ${
                                sub.isCompleted == 1
                                  ? "#22C55E"
                                  : sub.isCompleted == 2
                                  ? "#9CA3AF"
                                  : "#3B82F6"
                              }`,
                              backgroundColor:
                                sub.isCompleted == 1
                                  ? "#22C55E1A"
                                  : sub.isCompleted == 2
                                  ? "#F3F4F6"
                                  : "#3B82F61A",
                              p: 1,
                            }}
                          >
                            <Box
                              key={subIndex}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                borderRadius: 1,
                              }}
                            >
                              {sub.isCompleted == 1 ? (
                                <CheckCircleIcon
                                  sx={{ color: "#22C55E", fontSize: 30, mx: 1 }}
                                />
                              ) : sub.isCompleted == 2 ? (
                                <FeedIcon
                                  sx={{ color: "#9CA3AF", fontSize: 24, mx: 1 }}
                                />
                              ) : (
                                <AccessTimeIcon
                                  sx={{ color: "#3B82F6", fontSize: 30, mx: 1 }}
                                />
                              )}
                              <Typography
                                fontSize={14}
                                fontWeight={500}
                                sx={{
                                  textTransform: "capitalize",
                                  fontFamily: "Geist, sans-serif",
                                  fontSize: "14",
                                  marginTop: "5px",
                                }}
                              >
                                {sub?.RSP_Name || "Unnamed Sub"}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                alignContent: "center",
                                justifyContent: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                fontSize={14}
                                sx={{
                                  textTransform: "capitalize",
                                  fontFamily: "Geist, sans-serif",
                                }}
                              >
                                {stageStatusSubField?.RPF_Name &&
                                stageStatusSubField?.RPF_Value
                                  ? `${stageStatusSubField?.RPF_Name} : ${stageStatusSubField?.RPF_Value}`
                                  : null}
                              </Typography>

                              {stageStatusSubFieldPosition && (
                                <Typography
                                  sx={{ color: subColor.border }}
                                  fontSize="14"
                                >
                                  {stageStatusSubFieldPosition.RPF_Value
                                    ? `${stageStatusSubFieldPosition?.RPF_Name} : `
                                    : ""}
                                  {Array.isArray(
                                    stageStatusSubFieldPosition.RPF_Value
                                  )
                                    ? stageStatusSubFieldPosition.RPF_Value.join(
                                        ", "
                                      )
                                    : stageStatusSubFieldPosition.RPF_Value ||
                                      ""}
                                </Typography>
                              )}

                              {/* New Implementation - 09-09-25 - Expiry Date */}

                              {sub?.fields?.map((field) => {
                                const status = getExpiryStatus(field);
                                return (
                                  <Box key={field.RPF_Id}>
                                    {status && (
                                      <Typography
                                        sx={{
                                          fontSize: status?.fontSize,
                                          color: status?.color,
                                          textTransform: "Capitalize",
                                        }}
                                      >
                                        {status?.value}
                                      </Typography>
                                    )}
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        );
                      })}
                  </Box>
                );
              })}
            </Box>
          </Grid>
        )}
      </Grid>

      <CandidateProfilePage isDash={true} />

      <Grid container spacing={3}>
        {/* Notifications */}
        {notifications?.length > 0 && (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box
              sx={{
                border: "1px solid #006CB880",
                borderRadius: "10px",
                minHeight: "200px",
                padding: "20px",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  alignItems: "center",
                  marginBottom: "20px",
                  gap: 1, // optional spacing between wrapped items
                }}
              >
                <Typography
                  sx={{
                    px: 2,
                    textAlign: "left",
                    mt: 0.5,
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: "0.5px",
                    fontSize: "30px",
                    color: "#333",
                    fontWeight: 600,
                    flexGrow: 1,
                  }}
                >
                  Notifications
                </Typography>

                <Button
                  variant="text"
                  onClick={() => Navigate(`/Notifications`)}
                  sx={{
                    minWidth: "100px",
                    color: "white",
                    background: "#006CB8",
                    mt: 0.5,
                    height: "30px",
                    textTransform: "capitalize",
                    ml: { xs: "auto", sm: 0 }, // pushes right when wrapped
                  }}
                >
                  View All
                </Button>
              </Box>

              <Box pl={2}>
                {notifications?.length > 0
                  ? notifications.slice(0, 4).map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: "relative",
                          top: "5px",
                          minHeight: { sm: "", md: "70px" },
                          // border: "2px solid red",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent={"flex-start"}
                          alignContent={"flex-start"}
                          spacing={2}
                        >
                          <Box
                            display="flex"
                            alignContent={"flex-start"}
                            gap={1}
                          >
                            <CircleIcon
                              color="info"
                              sx={{
                                width: 15,
                                color: "#006CB8",
                                position: "relative",
                                top: "2px",
                              }}
                            />
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontFamily: "Geist, sans-serif",
                                letterSpacing: `0.5px`,
                                fontSize: "18px",
                                color: "#333",
                                fontWeight: "400",
                              }}
                            >
                              {item.NM_Message}
                            </Typography>
                          </Box>
                        </Stack>
                      </Box>
                    ))
                  : ""}
              </Box>
            </Box>
          </Grid>
        )}

        {/* Job Summary */}

        {candidateJobData?.length > 0 &&
          candidateJobData.some((obj) =>
            Object.values(obj).some((value) => value !== null)
          ) && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box
                sx={{
                  border: "1px solid #006CB880",
                  borderRadius: "10px",
                  minHeight: "200px",
                  padding: "20px",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    alignItems: "center",
                    marginBottom: "20px",
                    gap: 1, // optional spacing between items
                  }}
                >
                  <Typography
                    sx={{
                      px: 2,
                      textAlign: "left",
                      fontFamily: "Geist, sans-serif",
                      letterSpacing: "0.5px",
                      fontSize: "30px",
                      color: "#333",
                      fontWeight: 600,
                      flexGrow: 1, // take as much space as needed
                    }}
                  >
                    Job Summary
                  </Typography>

                  <Button
                    variant="text"
                    onClick={() => Navigate(`/Summary`)}
                    sx={{
                      minWidth: "100px",
                      color: "white",
                      background: "#006CB8",
                      mt: 0.5,
                      height: "30px",
                      textTransform: "capitalize",
                      ml: { xs: "auto", sm: 0 }, // push to right on wrap
                    }}
                  >
                    View All
                  </Button>
                </Box>

                <Box pl={2}>
                  {candidateJobData?.length
                    ? candidateJobData.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            position: "relative",
                            top: "5px",
                            minHeight: { sm: "", md: "70px" },
                            padding: "6px 0px",
                          }}
                        >
                          {/* Bullet marker */}
                          <Box
                            sx={{
                              position: "absolute",
                              left: 0,
                              top: "10px",
                              width: 12,
                              height: 12,
                              bgcolor: "#006CB8",
                              borderRadius: "50%",
                              zIndex: 1,
                            }}
                          />

                          {/* Content */}
                          <Grid
                            container
                            spacing={1}
                            alignItems="flex-start"
                            sx={{
                              position: "relative",
                              bottom: "5px",
                              pl: "20px",
                              // border: {
                              //   xs: "2px solid yellow",
                              //   sm: "2px solid red",
                              //   md: "2px solid blue",
                              //   lg: "2px solid green",
                              //   xl: "2px solid violet",
                              // },
                            }}
                          >
                            {/* Title + JobId */}
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={8}>
                              <Typography
                                sx={{
                                  textAlign: "left",
                                  fontFamily: "Geist, sans-serif",
                                  letterSpacing: `0.5px`,
                                  fontSize: "18px",
                                  color: "#333",
                                  fontWeight: "600",
                                }}
                              >
                                {item?.JD_Title}
                              </Typography>
                              <Typography
                                sx={{
                                  textAlign: "left",
                                  fontFamily: "Geist, sans-serif",
                                  letterSpacing: `0.5px`,
                                  fontSize: "14px",
                                  color: "#333",
                                  fontWeight: "400",
                                }}
                              >
                                {item?.JD_JobId}
                              </Typography>
                            </Grid>

                            {/* Date + Status */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={4}
                              textAlign={{
                                xs: "left",
                                sm: "left",
                                md: "left",
                                lg: "left",
                                xl: "right",
                              }}
                              sx={{ pr: { sm: 2 } }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Geist, sans-serif",
                                  letterSpacing: `0.5px`,
                                  fontSize: "16px",
                                  color: "#333",
                                  fontWeight: "600",
                                }}
                              >
                                {item?.JA_AppliedDate}
                              </Typography>
                              <Chip
                                label={item?.JASL_Name}
                                sx={{
                                  minWidth: "100px",
                                  color: `white`,
                                  backgroundColor: `#006CB8`,
                                  mt: 0.5,
                                }}
                                size="small"
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      ))
                    : ""}
                </Box>
              </Box>
            </Grid>
          )}
      </Grid>
    </Paper>
  );
};

export default CandidateDash;
